<template>
  <div class="dbNavList">
    <div class="flex a-c" style="margin-bottom: 20px">
      <div class="input-container flex a-c" style="flex: 1">
        <el-input v-model="paramsFilter.search" clearable @clear="getTable" @keyup.enter="getTable" placeholder="请输入数据库名称" />
        <div class="button-container" @click="getTable"><i class="iconfont unify-sousuo"></i></div>
      </div>
      <el-button type="primary" class="primary-btn export-btn" :loading="exportLoading" @click="handleExport">
        导出<el-icon style="margin-left: 6px;"><Download /></el-icon>
      </el-button>
    </div>
    <div class="flex ">
      <div class="filter-container" style="flex:1">

        <div class="alphabet-row filter-row">
          <div class="filter-tip">首字母：</div>
          <div class="filter-item" :class="'' == paramsFilter.letter ? 'checked' : ''"
            @click="handlerFilterRequestClick('letter', '')">全部
          </div>
          <div class="filter-item" :class="item == paramsFilter.letter ? 'checked' : ''"
            @click="handlerFilterRequestClick('letter', item)" v-for="item in state.filterListObj.alphabetList"
            :key="item">{{ item }}
          </div>
        </div>
        <template v-if="state.filterListObj.customDatabaseTypeFlag">
          <div class="resource-row filter-row">
            <div class="filter-tip">类型：</div>
            <div class="filter-item" :class="'' == paramsFilter.documentTypeStr ? 'checked' : ''"
              @click="handlerFilterRequestClick('documentTypeStr', '')">全部
            </div>
            <div class="filter-item" :class="item.value == paramsFilter.documentTypeStr ? 'checked' : ''"
              @click="handlerFilterRequestClick('documentTypeStr', item.value)"
              v-for="item in state.filterListObj.documentTypeListStr" :key="item.value">{{ item.name }}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="resource-row filter-row">
            <div class="filter-tip">类型：</div>
            <div class="filter-item" :class="'' == paramsFilter.documentType ? 'checked' : ''"
              @click="handlerFilterRequestClick('documentType', '')">全部
            </div>
            <div class="filter-item" :class="item.value == paramsFilter.documentType ? 'checked' : ''"
              @click="handlerFilterRequestClick('documentType', item.value)"
              v-for="item in state.filterListObj.documentTypeList" :key="item.value">{{ item.name }}
            </div>
          </div>
        </template>

      </div>

      <!-- <div class="button" style="flex-shrink: 0;margin-top: auto;padding-bottom: 20px;">

        <el-button type="primary" class="primary-btn" @click="editPublish">批量发布<el-icon style="margin-left: 6px;">
            <Operation />
          </el-icon></el-button>
      </div> -->
    </div>

    <div>
      <el-table :data="state.tableData" max-height="calc(100vh - 430px)" stripe style="width: 100%" class="my-table"
        row-key="id" :tree-props="{ children: 'childNode' }" :expand-row-keys="expandRowKeys" :indent="24"
        v-loading="tableLoading">
        <el-table-column prop="date" label="数据库" width="320px">
          <template #default="scope">
            <span class="db-name-wrap">
              <span @click="configDetailClick(scope.$index, scope.row)" class="row-name" v-html="scope.row.dbName"></span>

              <img class="tag-img" v-if="scope.row.configFlag==0" :src="iconEnum[1].imageUrl" />
              <!--              <span v-if="scope.row.configFlag==0 && scope.row.topFlag==1"></span>-->
              <img class="tag-img" v-if="scope.row.topFlag==1" :src="iconEnum[0].imageUrl" />
              <el-tooltip class="box-item" effect="light" content="数据库订购状态异常，请核实，关闭显示后该数据库不再出现" placement="top-start">
                <i v-if="scope.row.configureOrderExceptionFlag==1"
                  class="iconfont unify-iconfontxiaogantanhao red"></i>
              </el-tooltip>
              <!-- <el-tooltip
                class="box-item"
                effect="light"
                content="数据库订购时间设置异常"
                placement="top-start"
            >
              <i v-if="scope.row.orderTimeExceptionFlag==1" class="iconfont unify-iconfontxiaogantanhao yellow"></i>
            </el-tooltip> -->
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="languageName" label="中外类型" width="180" align="center">
          <template #header>
            <unifySelect placeholder="中外类型"
              @handlerSelectEvent="(value)=>handlerFilterNotRequestClick('language',value)"
              :options="state.filterListObj.languageTypeList" />
          </template>
        </el-table-column>
        <el-table-column prop="propertyNameStr" label="类型" align="center">
          <template #default="scope">
            {{scope.row.propertyNameStr || '-'}}
          </template>
        </el-table-column>
        <el-table-column prop="totalFlagStr" label="层级" align="center" width="180">
          <template #header>
            <unifySelect placeholder="层级" @handlerSelectEvent="(value)=>handlerFilterNotRequestClick('totalFlag',value)"
              :options="state.filterListObj.levelList" />
          </template>
        </el-table-column>
        <el-table-column prop="contractEndTime" label="到期日期" align="center">
          <template #default="scope">
            {{ scope.row.contractEndTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="orderStateName" label="订购状态" align="center" width="180">
          <template #header>
            <unifySelect placeholder="订购状态"
              @handlerSelectEvent="(value)=>handlerFilterNotRequestClick('orderState',value)"
              :options="state.filterListObj.orderStateList" />
          </template>
        </el-table-column>
        <el-table-column prop="openFlagStr" label="展示状态" align="center" width="180">
          <template #header>
            <div class="flex a-c j-c">
              <unifySelect placeholder="展示状态"
                @handlerSelectEvent="(value)=>handlerFilterNotRequestClick('openFlag',value)"
                :options="state.filterListObj.openTypeList" />
              <el-tooltip effect="dark" content="仅控制页面列表是否展示，隐藏不影响资源使用" placement="top">
                <el-icon class="header-tip"><QuestionFilled /></el-icon>
              </el-tooltip>
            </div>
          </template>
          <template #default="{row}">
            <!-- {{ scope.row.openFlagStr || '-' }} -->
            <div class="show-box" v-loading='row.loading'>
              <!-- <el-switch v-model="row.openFlag" :active-value='1' :inactive-value="0" active-text="展示中" inactive-text="未展示"
                @change="switchChange($event , row)" :before-change="beforeChange">
              </el-switch> -->
              <el-switch v-model="row.openFlag" :active-value="1" :inactive-value="0" active-text="已发布"
                inactive-text="未发布" inline-prompt :before-change="beforeChange" @change="switchChange($event, row)"
                active-color="#2054D6" size="large" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="disableFlagStr" label="禁用状态" align="center" width="180">
          <template #header>
            <div class="flex a-c j-c">
              <unifySelect placeholder="禁用状态"
                @handlerSelectEvent="(value)=>handlerFilterNotRequestClick('disableFlag',value)"
                :options="state.filterListObj.disableFlagList" />
              <el-tooltip effect="dark" content="禁用后数据库对应的资源不可被业务查询" placement="top">
                <el-icon class="header-tip"><QuestionFilled /></el-icon>
              </el-tooltip>
            </div>
          </template>
          <template #default="{row}">
            <div class="show-box" v-loading='row.disableLoading'>
              <el-switch v-model="row.disableFlag" :active-value="1" :inactive-value="0" active-text="禁用中"
                inactive-text="未禁用" inline-prompt :before-change="beforeChange" @change="switchDisableChange($event, row)"
                active-color="#2054D6" size="large" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center" fixed="right" width="220px">
          <template #default="scope">
            <span class="config-text-button" @click="configDetailClick(scope.$index, scope.row)">配置详情</span>
            <span class="edit-text-button" v-if="scope.row.topFlag==1"
              @click="cancelFirst(scope.$index, scope.row)">取消置顶</span>
            <span class="edit-text-button" v-if="scope.row.topFlag!=1 && scope.row.configFlag!=0"
              @click="cancelFirst(scope.$index, scope.row)">置顶</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex a-c" style="justify-content: flex-end;margin-top: 20px">
        <span style="margin-right: 12px;color: #6573A2;font-size: 16px">总数：{{ total }}</span>
        <div class="page-button-pre" @click="handlePageClick(false)">上一页</div>
        <el-pagination background layout="pager,sizes" v-model:page-size="paramsFilter.pageSize" :page-sizes="[5,10,20]"
          :current-page="paramsFilter.pageNum" @current-change="handlerPageNumChange"
          @size-change="handlerPageSizeChange" :total="total" />
        <div class="page-button-next" @click="handlePageClick(true)">下一页</div>
      </div>
    </div>


    <!-- 批量管理 -->
    <template v-if="publishEdit.dialogFlag">
      <publishDialog v-model="publishEdit.dialogFlag" @update="updata"></publishDialog>
    </template>
  </div>
</template>

<script>
import {findDatabaseManageList, findManagerQueryParamList, setTopFlag , openDatabase, toggleDatabaseDisable, exportDatabaseManageList} from "@/js/network/main"
import {reactive, toRefs, ref, isReactive , onActivated} from "vue";
import unifySelect from "@/components/defineElementPlus/unifySelect"
import router from "@/router"
import {iconEnums} from "../../until"
import {MessageBox} from "@/js/utils/commonJs";
import {download} from "@/js/utils/download";
import publishDialog from '@/views/DbConfig/DbNavManage/DbNavList/components/publishEdit.vue'
import { ElMessageBox } from "element-plus";
import { Download, QuestionFilled } from "@element-plus/icons-vue";

export default {
  name:"dbNavList",
  components: {
    unifySelect,
    publishDialog,
    Download
  },
  setup(props, context) {

    onActivated(() => {
      getTable()
    })
    

    const iconEnum = iconEnums;
    let tableLoading = ref(true);
    let exportLoading = ref(false);
    let openDatabaseConfig = reactive({
      isUserEditFlag:false
    })
    let paramsFilter = reactive({ // 筛选参数
      search: "",//搜索关键词
      letter: "",//搜索字母
      documentType: "",//资源类型
      documentTypeStr: "",//资源类型
      pageSize: 10,//当前页大小
      pageNum: 1,//当前页
      language: "",//中外文类型
      totalFlag: "",//层级
      orderState: "",//订购状态
      openFlag: "",//展示状态 1 开启  0关闭
      disableFlag: "",//禁用状态 1 禁用中 0 未禁用

    });
    let state = reactive({
      tableData: [],
      filterListObj: {},// 表头筛选枚举
    })
    let total = ref(0);
    // 默认展开的行（openFlag=1 且有子集）
    let expandRowKeys = ref([]);

    // 递归处理树：叶子行删掉空 childNode（避免出现无意义的展开箭头），收集需默认展开的行 id
    const normalizeTree = function (list, keys) {
      list.forEach(item => {
        if (item.childNode && item.childNode.length > 0) {
          normalizeTree(item.childNode, keys);
          if (item.openFlag == 1) {
            keys.push(String(item.id));
          }
        } else {
          delete item.childNode;
        }
      });
    };


    let publishEdit = reactive({
      dialogFlag:false,
      edit:{},
      loading:false
    })

    const beforeChange = () => {
      return new Promise((resolve, reject) => {
        ElMessageBox.confirm('确定要执行本操作吗?').then((aaa) => {
          if (aaa) {
            openDatabaseConfig.isUserEditFlag = true;
            resolve(true);
          }
          reject(false);
        }).catch(() => {
          reject(false);
        })
      })

    }

    const switchChange = (val , row) => {
      console.log('val , row: ', val , row);
      if(!openDatabaseConfig.isUserEditFlag) return
      openDatabaseConfig.isUserEditFlag = false;
      row.loading = true;
      openDatabase({ id: row.id }).then(res => {
        row.loading = false;
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        MessageBox.success("操作成功！");
      }).catch(error => {
        row.loading = true;
        row.openFlag = val == 1 ? 0 : 1; //失败了 返回原来的状态
        console.log('error32323: ', error);
        openDatabaseConfig.isUserEditFlag = false;
      });
    }

    // 禁用状态开关（同展示状态逻辑）
    const switchDisableChange = (val , row) => {
      if(!openDatabaseConfig.isUserEditFlag) return
      openDatabaseConfig.isUserEditFlag = false;
      row.disableLoading = true;
      toggleDatabaseDisable({ id: row.id }).then(res => {
        row.disableLoading = false;
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        MessageBox.success("操作成功！");
      }).catch(error => {
        row.disableLoading = false;
        row.disableFlag = val == 1 ? 0 : 1; //失败了 返回原来的状态
        console.log('error32323: ', error);
        openDatabaseConfig.isUserEditFlag = false;
      });
    }

    const editPublish = () =>{
      publishEdit.dialogFlag = true;
    }
    
    const getParamsEnums = function () {
      findManagerQueryParamList().then(res => {
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        if (!res || !res.data) {
          return;
        }
        state.filterListObj = {...res.data};
        state.filterListObj.alphabetList = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];//字母表
        state.filterListObj.disableFlagList = [{ name: '禁用中', value: 1 }, { name: '未禁用', value: 0 }];//禁用状态（前端写死）
      }).catch(error => {
        //MessageBox.error(error);
        console.log(error, "catchError");
      })
    }
    //初始化操作
    const getTable = function () {
      tableLoading.value = true;
      findDatabaseManageList(paramsFilter).then(res => {
        if (!res || !res.data) {
          tableLoading.value = false;
          return;
        }
        state.tableData = res.data.map(v => {
          return {
            ...v,
            loading:false
          }
        });
        // 处理子集树 + 收集默认展开行
        let keys = [];
        normalizeTree(state.tableData, keys);
        expandRowKeys.value = keys;
        total.value = parseInt(res.count);
        tableLoading.value = false;
      }).catch(error => {
        if (error.message == "Request Canceled!") {
          return
        }
        tableLoading.value = false;
      });

    }

    //筛选并请求
    const handlerFilterRequestClick = function (key, value) {
      paramsFilter[key] = value;
      paramsFilter.pageNum = 1;
      getTable();
    }

    //表格头组件自定义事件
    const handlerFilterNotRequestClick = function (key, value) {
      paramsFilter[key] = value;
      getTable();
    }

    const handlerPageNumChange = function (num) {
      paramsFilter.pageNum = num;
      getTable();
    }
    const handlerPageSizeChange = function (num) {
      paramsFilter.pageSize = num;
      paramsFilter.pageNum = 1;
      getTable();
    }


    const updata = () => {
      paramsFilter.pageSize = 10;
      paramsFilter.pageNum = 1;
      getTable();
    }

    const configDetailClick = function (index, row) {
      router.push({
        path: "/dbConfig/detailSetting",
        query: {
          id: row.id,
          dId: row.dId
        }
      });
    }
    const cancelFirst = function (index, row) {
      setTopFlag({id: row.id}).then(res => {
        if (!res.success) {
          MessageBox.error(res.msg);
          return;
        }
        MessageBox.success("操作成功！");
        getTable();
      }).catch(error => {
        //MessageBox.error(error);
        console.log(error, "catchError");
      });
    }
    const handlePageClick = function (flag) {
      flag ? paramsFilter.pageNum++ : paramsFilter.pageNum--;
      if(paramsFilter.pageNum<1){
        paramsFilter.pageNum = 1;
        return;
      }
      let max = Math.ceil(total.value/paramsFilter.pageSize);
      if(paramsFilter.pageNum>max){
        paramsFilter.pageNum = max;
        return;
      }
      getTable();
    }

    // 导出：查询条件与列表查询完全一致，后端不分页取全量
    const handleExport = function () {
      if (exportLoading.value) return;
      exportLoading.value = true;
      exportDatabaseManageList(paramsFilter).then(res => {
        exportLoading.value = false;
        download(res, "", 'excel');
      }).catch(error => {
        exportLoading.value = false;
        console.log(error, "catchError");
      });
    }

    //setup 不需要create生命周期，此方法就相当于是create生命周期
    //获取参数
    getParamsEnums();
    getTable();

    return {
      tableLoading,
      exportLoading,
      iconEnum,
      paramsFilter,
      state,
      total,
      expandRowKeys,
      getTable,
      handleExport,
      handlerFilterRequestClick,
      handlerFilterNotRequestClick,
      handlePageClick,
      handlerPageNumChange,
      handlerPageSizeChange,
      configDetailClick,
      cancelFirst,
      editPublish,
      publishEdit,
      updata,
      switchChange,
      switchDisableChange,
      beforeChange
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.unify-iconfontxiaogantanhao {
  margin-left: 8px;
  font-weight: 600;

  &.red {
    color: red;
  }

  &.yellow {
    color: #fca506;
  }
}

.dbNavList {
  padding-top: 20px;
  background-color: #ffffff;
  border-radius: 20px 0 0 0;
}
.row-name{
  cursor: pointer;

  // 兼容检索高亮标签<em>（覆盖public.scss的背景色）
  :deep(em) {
    font-style: normal;
    font-weight: bold;
    color: red;
    background: none;
  }
}
.row-name:hover{
  text-decoration: underline;
}
.header-tip{
  margin-left: 2px;
  color: #909399;
  cursor: pointer;
}

.input-container {
  height: 38px;
  border: 1px solid #ccc;
  border-radius: 4px;

  .iconfont {
    font-size: 20px;
    font-weight: 600;
  }
}

.export-btn {
  flex-shrink: 0;
  margin-left: 20px;
}

.input-container:focus-within {
  border: 1px solid #409eff;
}

.button-container {
  height: 40px;
  width: 64px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
  background: #2054D6;
  border-radius: 0px 2px 2px 0;
}

:deep(.el-input__wrapper) {
  box-shadow: none !important;
  background: transparent !important;

  &.is-focused {
    box-shadow: none !important;
  }

  &.is-hovering {
    box-shadow: none !important;
  }
}

.filter-container {
  margin-bottom: 20px;
  box-sizing: border-box;
  font-size: 14px;
}

.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
}

.filter-tip {
  text-align: left;
  width: 56px;
  margin-bottom: 15px;
  margin-right: 10px;
  color: #000000;
}

.filter-item {
  padding: 4px 5px;
  margin-bottom: 15px;
  margin-right: 20px;
  white-space: nowrap;
  user-select: none;
  color: #2B3348;
  line-height: 14px;
  cursor: pointer;

  &.checked {

    color: #ffffff;
    background-color: #2054D6;
    border-radius: 2px;
  }
}

.tag-img {
  display: inline-block;
  height: 17px;
  margin-left: 8px;
  position: relative;
  top: 2px;
}

.config-text-button {
  font-size: 14px;
  color: #1239A6;
  user-select: none;
  cursor: pointer;
  text-decoration: underline;
  margin-right: 8px;
}

.edit-text-button {
  font-size: 14px;
  color: #FC3535;
  user-select: none;
  cursor: pointer;
  text-decoration: underline;
}

.my-table {
  border: 1px solid #DCE1F0;
  border-radius: 10px 10px 10px 10px;
}

.page-button-next {
  width: 72px;
  height: 40px;
  background: #EEF2FE;
  border-radius: 10px 10px 10px 10px;
  font-size: 16px;
  color: #6573A2;
  line-height: 40px;
  text-align: center;
  opacity: 1;
  border: 1px solid #DCE1F0;
  user-select: none;
  cursor: pointer;
  margin-left: 15px;
}

.page-button-pre {
  width: 72px;
  height: 40px;
  background: #EEF2FE;
  border-radius: 10px 10px 10px 10px;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  color: #6573A2;
  opacity: 1;
  border: 1px solid #DCE1F0;
  user-select: none;
  cursor: pointer;
  margin-right: 15px;
}

:deep(.el-table__header) {


  border-radius: 10px 10px 0px 0px;
  opacity: 1;
  height: 64px;

  .el-table__cell {
    background: #EEF2FE !important;
    color: #6573A2;
  }
}

:deep(.el-table__row) {
  height: 64px;

  .el-table__cell {
    color: #6573A2;
  }
}

:deep(.el-table__row--striped) {

  .el-table__cell {
    background: #F8F9FD !important;
  }
}

:deep(.el-pager) {
  .number {
    font-size: 14px;
    color: #6573A2;
    background: none !important;
  }

  .more {
    background: none !important;
  }

  .is-active {
    width: 40px;
    height: 40px;
    background: #2054D6 !important;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    border: 1px solid #DCE1F0;
  }
}

</style>
